import { API } from "@/lib/api";

export const stickerUrl = (s) => {
  const st = typeof s === "string" ? { id: s } : s;
  if (st.id !== "custom") return `${API}/fx/sticker/${st.id}.png`;
  return `${API}/fx/sticker/custom.png?text=${encodeURIComponent(st.text || "GG")}&style=${st.style || "chrome"}`;
};
export const sfxUrl = (id) => `${API}/fx/sfx/${id}.mp3`;
export const playSfx = (id, vol = 0.85) => {
  const a = new Audio(sfxUrl(id));
  a.volume = Math.min(1, Math.max(0, vol));
  a.play().catch(() => {});
  return a;
};
export const sfxLabel = (cat, id, lang) => {
  const s = cat.sfx.find((x) => x.id === id);
  return s ? (lang === "fr" ? s.fr : s.en) : id;
};
export const stickerLabel = (cat, s) => (s.id === "custom" ? s.text || "GG" : cat.stickers.find((x) => x.id === s.id)?.text || s.id);
